import React from 'react';
import { TableHeaderColumn, TableRow } from 'material-ui/Table';
import {
  tableHeaderColumnStyles,
  tableRowStyles,
  tableActionColumnStyles
} from '../styles';

export default () => (
  <TableRow style={tableRowStyles}>
    <TableHeaderColumn style={tableHeaderColumnStyles}>
      Fuel Card Number
    </TableHeaderColumn>
    <TableHeaderColumn style={tableHeaderColumnStyles}>
      Provider
    </TableHeaderColumn>
    <TableHeaderColumn style={tableHeaderColumnStyles}>
      Vehicle Rego
    </TableHeaderColumn>
    <TableHeaderColumn style={tableHeaderColumnStyles}>
      Card Status
    </TableHeaderColumn>
    <TableHeaderColumn style={tableHeaderColumnStyles}>
      Issued Date
    </TableHeaderColumn>
    <TableHeaderColumn style={tableActionColumnStyles} />
  </TableRow>
);



// WEBPACK FOOTER //
// ./src/features/fuel-cards/fuel-card-table/fuel-card-table-header.js